import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useMapLayerLogoStyles = makeStyles(({ spacing }) => {
  return createStyles({
    logo: {
      position: 'absolute',
      bottom: spacing(2.5),
      left: spacing(11),
    },
  });
});

export default useMapLayerLogoStyles;
